/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import Dotdotdot from 'react-dotdotdot';
import ModalVideo from 'react-modal-video';
import LinkAnchor from '../../Links/LinkAnchor';

import styles from './infoCards.module.scss';

class InfoCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            videoLink: null,
        };
        this.openModal = this.openModal.bind(this);
        this.openVideo = this.openVideo.bind(this);
        this.getLink = this.getLink.bind(this);
    }

    getLink(link, copy) {
        if (link.startsWith('https') && link.split('v=')[1]) {
            return <div className={styles.readmore} onClick={() => this.openVideo(link)}>{copy}</div>;
        }
        return (
            <LinkAnchor href={link} className={`text-`}>
                <div className={`btn btn-primary`}>{copy}</div>
            </LinkAnchor>
        );
    }

    openVideo(link) {
        this.setState({ videoLink: link.split('v=')[1] });
        this.openModal('video1');
    }

    openModal(video) {
        this.setState({ isOpen: video });
    }

    render() {
        const { infoCards } = this.props;
        return (
            <div id={'infoCardContainer'} className={`container ${styles.container} ${this.props.className}`}>
                <div className={`row`}>
                    {infoCards.map((card, i) => (
                        <div className={`col-12 col-md-4`} key={`infocard-${i}`}>
                            <div className={`info-card`}>
                                <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video1'} videoId={this.state.videoLink} autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                                <div className={`${styles.cardTitle} ellipsis`}>
                                    {card.title}
                                </div>
                                <div className={`${styles.copy}`}>
                                    <Dotdotdot clamp={2}>
                                        {card.description}
                                    </Dotdotdot>
                                </div>
                                <div className={styles.div} />
                                {this.getLink(card.cta_link, card.cta_copy)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default InfoCards;
